import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { StatsPage } from './pages/admin/panels/StatsPage';
import { UsersPage } from './pages/admin/panels/UsersPage';
import { PostsPage } from './pages/admin/panels/PostsPage';
import { CommentsPage } from './pages/admin/panels/CommentsPage';
import { ReportsPage } from './pages/admin/panels/ReportsPage';
import { SettingsPage } from './pages/admin/panels/SettingsPage';
import { UserLayout } from './pages/UserLayout';
import { DashboardPage } from './pages/DashboardPage';
import { DivinationPage } from './pages/DivinationPage';
import { BoardPage } from './pages/BoardPage';
import { PostDetailPage } from './pages/PostDetailPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { MePage } from './pages/MePage';

/**
 * Web 桌面端根路由（PLAN §8 / §6.5）
 * - 用户端：/ 、/divination 、/board 、/board/:id 、/me 、/notifications
 * - 管理端：/admin/*（用户端导航不暴露入口，仅直接 URL 可达；子路由 = 侧栏菜单）
 */
export default function App() {
  return (
    <Routes>
      {/* 用户端 */}
      <Route element={<UserLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="/divination" element={<DivinationPage />} />
        <Route path="/board" element={<BoardPage />} />
        <Route path="/board/:id" element={<PostDetailPage />} />
        <Route path="/me" element={<MePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
      </Route>
      {/* 管理端：登录页独立；布局内子路由对应侧栏菜单 */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<StatsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="posts" element={<PostsPage />} />
        <Route path="comments" element={<CommentsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
      {/* 未知路径回首页 */}
      <Route path="*" element={<DashboardPage />} />
    </Routes>
  );
}
